// The Tools bubble's registration: the window `tools` and Home's Input Tools item.
import { registerWindow } from '../../core/windows.js'
import { registerHomeItem } from '../../core/home-items.js'

registerWindow('tools', { module: () => import('./tools.js'), css: 'windows/tools/tools.css', title: () => 'Input Tools', place: ['home', 'below'] })
registerHomeItem({ id: 'tools', label: 'Input Tools', symbol: 'keyboard', needs: '', section: 'toolbar', order: 10 })
